// Temporary redirect for emails and bookmarks created before the tax-binder rename.
// /preparer/binders → /preparer/tax-binders.
// Remove approximately 6 weeks after release (around 2026-06-15).
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/preparer/binders/')({
  beforeLoad: () => {
    throw redirect({
      to: '/preparer/tax-binders',
      replace: true,
    });
  },
  component: () => null,
});
